import { CSSObject } from '@chakra-ui/react';

export const FlexResponsibleGamblingSlideContainer: CSSObject = {
  border: 'none',
};

export const FlexTextContainer: CSSObject = {
  maxWidth: 'unset',
};
